import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatGs, LOCATION_NAMES, formatDate } from "@/lib/format";
import { Bell, AlertTriangle, Ban } from "lucide-react";
import { VoidDecisionButtons } from "@/components/VoidActions";

export const AlertsBell = () => {
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/alerts").then((r) => setAlerts(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    window.addEventListener("cash-closed", load);
    return () => { clearInterval(t); window.removeEventListener("cash-closed", load); };
  }, []);
  const unread = alerts.filter((a) => !a.read).length;
  const markAll = async () => { await api.post("/alerts/read-all"); load(); };

  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)} data-testid="alerts-bell" className="relative w-9 h-9 rounded-lg border border-border flex items-center justify-center hover:bg-accent transition-colors">
        <Bell className="w-4 h-4" />
        {unread > 0 && <span data-testid="alerts-count" className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-destructive text-white text-[10px] font-bold flex items-center justify-center">{unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-w-[90vw] card-surface p-3 z-50 shadow-xl" data-testid="alerts-panel">
          <div className="flex items-center justify-between mb-2">
            <p className="font-head font-bold text-sm">Alertas de caja</p>
            {unread > 0 && <button onClick={markAll} data-testid="alerts-read-all" className="text-xs text-primary font-semibold">Marcar leídas</button>}
          </div>
          <div className="space-y-2 max-h-80 overflow-y-auto">
            {alerts.length === 0 && <p className="text-xs text-muted-foreground text-center py-4">Sin alertas</p>}
            {alerts.map((a) => a.type === "anulacion" ? (
              <div key={a.id} className={`p-2.5 rounded-lg text-xs border space-y-1 ${a.resolved ? "border-border opacity-60" : "border-amber-500/50 bg-amber-500/5"}`} data-testid={`alert-${a.id}`}>
                <p className="font-semibold flex items-center gap-1.5"><Ban className="w-3.5 h-3.5 text-amber-500" /> Anular venta {formatGs(a.total)}</p>
                <p className="text-muted-foreground">{LOCATION_NAMES[a.location]} · {a.cashier} · {formatDate(a.timestamp)}</p>
                <p className="truncate">{a.items}</p>
                <p><b>Motivo:</b> {a.reason}</p>
                {a.resolved ? <p className="font-semibold">{a.decision === "aprobada" ? "Aprobada" : "Rechazada"} por {a.decided_by}</p>
                  : <VoidDecisionButtons saleId={a.sale_id} onDone={load} />}
              </div>
            ) : (
              <div key={a.id} className={`p-2.5 rounded-lg text-xs border ${a.read ? "border-border opacity-60" : "border-destructive/40 bg-destructive/5"}`} data-testid={`alert-${a.id}`}>
                <p className="font-semibold flex items-center gap-1.5"><AlertTriangle className="w-3.5 h-3.5 text-destructive" /> Diferencia {formatGs(a.difference)}</p>
                <p className="text-muted-foreground mt-0.5">{LOCATION_NAMES[a.location]} · {a.opened_by || a.cashier} · tolerancia {formatGs(a.threshold)}</p>
                <p className="text-muted-foreground">Esperado {formatGs(a.expected_cash)} · Contado {formatGs(a.counted_amount)} · {formatDate(a.timestamp)}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
